<template>
    <div id="cookbookselector"  class="cookbookselector" v-bind:class="[showselector?'open':'close']" v-bind:style="style" >
        <div class="wrapper">
            <div class="headline clearfix"><span>Meine Kochbücher</span><i class="fal fa-times" @click="hide()"></i></div>
            <vueperfectscrollbar  class="listwrapper" ref="scrollbar">
                <ul class="booklist">
                    <li class="selectorcheckbox" v-bind:class="{unchecked:!favourite_checked}">
                        <input id="favbookcheck" type="checkbox" value="" v-model="favourite_checked" @change="onChangeFavourites()"><label for="favbookcheck"><span>Favoriten</span></label>
                        <span class="counter">{{favourites.length}}</span>
                    </li>
                    <li class="selectorcheckbox" v-for="(book, index) in cookbooks" v-bind:class="{unchecked:!book.checked}">
                        <input v-bind:id="'book'+index" v-model="book.checked" v-bind:value="book" type="checkbox" @change="onChangeCookbook(book)"><label v-bind:for="'book'+index"><span>{{book.title}}</span></label>
                        <span class="counter">{{book.recipes.length}}</span>
                    </li>
                </ul>
            </vueperfectscrollbar>
            <div class="button-wrapper">
                <div v-if="!editnewbook"  class="addbook" >
                    <button class="btn btn-primary btn-icon-left" @click="onOpenCookbookEdit"><i class="fas fa-plus-circle"></i><span>Neues Kochbuch</span></button>
                    <button class="btn btn-secondary" @click="hide()">Schließen</button>
                </div>
                <div v-if="editnewbook" class="newbook">
                    <input ref="cookbookname"  v-on:keyup.esc="onCloseCookbookEdit" v-on:keyup.enter="onAddCookbook" class="form-control" type="text" v-model="cookbooktitle" placeholder="Kochbuchname">
                    <button class="btn btn-primary" @click="onAddCookbook" >Kochbuch speichern</button>
                    <button class="btn btn-secondary" @click="onCloseCookbookEdit">Abbrechen</button>
                </div>
            </div>            
            <div class="arrow"></div>
        </div>
    </div>  

</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        components: {
            'vueperfectscrollbar': VuePerfectScrollbar
        },
        props: {
            favourites: Array,
            cookbooks: Array,
            classes: {
                type: String,
                default: ''
            },
        },
        data: function () {
            return {
                recipe_el: null,
                heart_el: null,
                recipe: null,
                showselector: false,
                favourite_checked: false,
                editnewbook: false,
                cookbooktitle: '',
                style: {},
                mobile_width: 480,
                isMobil: false,
                resizetimer: null,
                initial_check: true
            };
        },
        created: function () {
            this.$eventbus.$on('resize-window', this.onResizeWindow);
        },
        mounted: function () {
            this.$nextTick(function () {
                this.$el.parentNode.removeChild(this.$el);
                document.body.appendChild(this.$el);
            });
        },
        methods: {
            show: function (recipe, element, initial_check) {
                if (recipe) {
                    this.recipe_el = element;
                    this.heart_el = element;
                    this.recipe = recipe;
                    this.editnewbook = false;
                    this.showselector = true;
                    this.initial_check = initial_check;
                    this.startSelector();
                }
            },
            hide: function () {
                this.showselector = false;
                if (this.isMobil) {
                    jQuery('html').removeClass('no-scroll');
                }
                this.$emit('close');
            },
            startSelector: function () {
                this.checkRecipeInCookbook();
                if (this.initial_check && !this.favourite_checked) {
                    this.favourite_checked = true;
                    this.onChangeFavourites();
                }
                this.showcookselector = true;
                this.$nextTick(function () {
                    this.onResizeCoobookSelector();
                    if (this.isMobil) {
                        jQuery('html').addClass('no-scroll');
                    }
                });
                this.scrollInView(this.heart_el);
            },
            onResizeWindow: function () {
                var that = this;
                if (this.showcookselector) {
                    if (!that.resizetimer) {
                        this.resizetimer = setTimeout(function () {
                            that.onResizeCoobookSelector();
                            that.resizetimer = null;
                        }, 100);
                    }
                }
            },
            onChangeCookbook: function (book) {
                this.$nextTick(function () {
                    var b = new Cookbook(JSON.parse(JSON.stringify(book)));
                    var r = new Recipe(JSON.parse(JSON.stringify(this.recipe)));
                    if (book.checked) {
                        this.$emit('add-to-cookbook', b, r);
                    } else {
                        this.$emit('remove-from-cookbook', b, r);
                    }
                });
            },
            onOpenCookbookEdit: function () {
                this.editnewbook = true;
                this.setListHeight();
                this.$nextTick(function () {
                    this.$refs['cookbookname'].focus();
                });
            },
            onCloseCookbookEdit: function () {
                this.editnewbook = false;
                this.cookbooktitle = '';
                this.setListHeight();
            },
            onAddCookbook: function () {
                var that = this;
                if (this.cookbooktitle.length) {
                    var r = new Recipe(JSON.parse(JSON.stringify(this.recipe)));
                    var book = new Cookbook();
                    book.title = this.cookbooktitle;
                    book.recipes = [r];
                    book.save();
                    book.checked = true;
                    this.cookbooks.push(book);
                    this.onCloseCookbookEdit();
                    this.$nextTick(function () {
                        var e = jQuery('.cookbookselector .ps-container.listwrapper');
                        e.scrollTop(e[0].scrollHeight - e[0].clientHeight);
                    });
                } else {
                    this.$message('Bitte einen Namen für das Kochbuch angeben.', {type: 'error'});
                }
            },
            checkRecipeInCookbook: function () {
                var that = this;
                this.cookbooks.forEach(function (element) {
                    if (element.isRecipes(that.recipe.id)) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                });
                this.favourite_checked = this.isLiked(this.recipe.id);
            },
            isLiked: function (id) {
                if (this.favourites && this.favourites.length) {
                    var item = this.favourites.find(function (element) {
                        return element.id == id
                    });
                    if (item) {
                        return true;
                    }
                }
                return false;
            },
            onChangeFavourites: function () {
                var that = this;
                var r = new Recipe(JSON.parse(JSON.stringify(this.recipe)));
                this.$nextTick(function () {
                    if (that.favourite_checked) {
                        r.isHeart = true;
                        this.$emit('add-favourite', r);
                        that.setHeart();
                    } else {
                        r.isHeart = false;
                        this.$emit('remove-favourite', r);
                        that.clearHeart();
                    }
                });
            },
            scrollInView(element) {
                if (jQuery(window).width() <= this.mobile_width) {
                    var e = jQuery(element).closest('.description-wrapper');
                    if (e.length) {
                        var offset = jQuery(e).offset();
                        jQuery('html, body').animate({
                            scrollTop: offset.top,
                            scrollLeft: 0
                        }, 750);
                    }
                }
            },
            setHeart: function () {
                var that = this;
                var like = new Like({"type": "recipe", "entity_id": this.recipe.id});
                like.save(function (data) {
                    jQuery(that.heart_el).addClass('active');
                });
            },
            clearHeart: function () {
                var that = this;
                var like = new Like({"type": "recipe", "entity_id": this.recipe.id});
                like.delete(function (data) {
                    jQuery(that.heart_el).removeClass('active');
                });
            },
            onResizeCoobookSelector: function () {

                var c_position = jQuery(this.recipe_el).offset();
                var c_height = jQuery(this.recipe_el).height();
                var c_width = jQuery(this.recipe_el).width();
                var b_width = jQuery(window).width();
                var b_height = jQuery(window).height();
                var h_height = 0;
                var b_position = jQuery(window).scrollTop();
                var width = jQuery('#cookbookselector').width();
                var height = jQuery('#cookbookselector').height();
                var arrow = jQuery('.cookbookselector .arrow');

                var y = 0;
                var y_diff = 0;
                var x_pos = 0;
                var y_pos = 0;
                jQuery('.cookbookselector .listwrapper').css('height', '');
                this.isMobil = false;
                if (b_width < this.mobile_width) {
                    b_height = b_height * 0.75;
                    x_pos = 0;
                    y = 0;
                    this.isMobil = true;
                    this.style = {top: 'unset', left: '0px', bottom: '0px'};
                    this.setListHeight();
                    return;
                } else if (b_width < 2 * width) {
                    x_pos = Math.max((b_width - width) / 2, 0);
                    var y1 = Math.max(b_position + ((b_height - h_height) - height) / 2, h_height + 10);
                    var y2 = b_position + h_height + 10;
                    y = Math.max(y1, y2);
                    arrow.removeClass('right');
                    arrow.removeClass('left');
                } else if ((c_position.left - width) < 0) {
                    x_pos = Math.max(c_position.left + c_width + 19, 0);
                    y = c_position.top + (c_height - (height / 2)) - (c_height / 2);
                    arrow.removeClass('right');
                    arrow.addClass('left');
                } else {
                    x_pos = Math.max(c_position.left - width - 19, 0);
                    y = c_position.top + (c_height - (height / 2)) - (c_height / 2);
                    arrow.removeClass('left');
                    arrow.addClass('right');
                }

                y_pos = Math.max(y, b_position);
                if (y == y_pos) {
                    y_pos = Math.min(y, b_position + b_height - height);
                }
                if (y != y_pos) {
                    var y_diff = y - y_pos;
                }
                var arrow_pos = (height / 2) + y_diff;
                arrow_pos = Math.max(26, arrow_pos);
                arrow_pos = Math.min(height - 26, arrow_pos);
                arrow.css('top', arrow_pos + 'px');
                this.style = {top: y_pos + 'px', left: x_pos + 'px'};
            },
            setListHeight: function () {
                var that = this;
                this.$nextTick(function () {
                    var b_height = jQuery(window).height() * 0.75; // 75vh Endhöhe
                    var b_width = jQuery('#cookbookselector').width();
                    var h = jQuery('.cookbookselector .button-wrapper').height();
                    var hh = jQuery('.cookbookselector .headline').height();
                    if (this.isMobil) {
                        jQuery('.cookbookselector .listwrapper').css('height', (b_height - hh - h - 40) + 'px');
                    }
                });

            },
        }
    }
</script>

